export default __webpack_public_path__ + "static/media/cStyleInfluencing.e4639e26.png";